<template>
  <v-layout
    :column="$vuetify.breakpoint.xsOnly"
    :class="[
      'ticket-timer-container',
      isZkm ? 'ticket-timer-container-zkm' : 'ticket-timer-container-regular',
    ]"
  >
    <v-flex>
      <v-layout row wrap>
        <div class="ticket-container">
          <span :class="['ticket-container-title', isZkm && 'ticket-container-title-zkm']">
            {{ $t('remainingTime') }}
          </span>
          <span class="timer" translate="no">{{ timer }}</span>
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { isRevolutCheckoutActive } from '@/revolut-checkout-state'

const TOTAL_TIME = 15 * 60
export default {
  name: 'checkout-timer',
  props: {
    serverRecovery: { type: Boolean, default: false },
    startTime: {
      type: Date,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    const end = moment(this.startTime).add(TOTAL_TIME, 'seconds')

    return {
      endTime: end,
      differenceInSeconds: this.calculateDiff(moment(new Date()), end),
      interval: null,
    }
  },
  computed: {
    timer: function () {
      var minutes = Math.floor(this.differenceInSeconds / 60)
      var seconds = Math.floor(this.differenceInSeconds % 60)

      return `${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`
    },
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
  },
  watch: { startTime() { this.startTimer() } },
  mounted() { this.startTimer() },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    startTimer() {
      clearInterval(this.interval)
      this.endTime = moment(this.startTime).add(TOTAL_TIME, 'seconds')
      this.differenceInSeconds = this.calculateDiff(moment(new Date()), this.endTime)
      this.interval = setInterval(() => {
        this.differenceInSeconds = this.calculateDiff(moment(new Date()), this.endTime)
        if (this.differenceInSeconds === 0 && !isRevolutCheckoutActive()) {
          clearInterval(this.interval)
          if (this.serverRecovery) this.$emit('expired')
          else {
            localStorage.removeItem('order')
            window.location.reload()
          }
        }
      }, 500)
    },
    calculateDiff(start, end) {
      return Math.max(end.diff(start, 'seconds'), 0)
    },
  },
}
</script>

<style scoped>
.ticket-timer-container-zkm {
  background: var(--grey-40, #f5f5f5) !important;
  color: #333333 !important;
  border-radius: 0px !important;
}

.ticket-timer-container {
  padding: 16px 8px 16px;
  border-radius: 8px;
  position: relative;
  margin-top: 20px;
}

@media screen and (max-width: 992px) {
  .ticket-timer-container {
    margin: 12px;
    margin-bottom: 30px;
  }
}
@media (min-width: 992px) and (max-width: 1440px) {
  .ticket-timer-container {
    border-radius: 8px 0 0 8px;
  }
}

.element-description {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.ticket-container-title {
  color: #333;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  font-size: 18px;
  padding-left: 10px;
}

.ticket-container {
  padding: 0px 20px 0px 10px;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  flex-direction: row;
}

.ticket-timer-container-regular {
  border-radius: 0.25rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #f5f5f5;
}

.timer {
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  color: #333333;
  font-family: Raleway, sans-serif;
  padding-left: 10px;
  font-feature-settings: 'pnum' on;
  font-feature-settings: 'lnum' on;
}
</style>
